import {
  LOAD_MASTERDATA_SUBLOCATION,
  CREATE_MASTERDATA_SUBLOCATION,
  UPDATE_MASTERDATA_SUBLOCATION,
  EXPORT_MASTERDATA_SUBLOCATION,
} from './actions'

const intialState = {
  lists: [],
  total: 1,
  loading: false,
  draw: -1,
}

export default (state = intialState, action) => {
  switch (action.type) {
    case LOAD_MASTERDATA_SUBLOCATION.REQUEST:
      const { loading } = action.payload
      return {
        ...state,
        loading: loading,
      }

    case LOAD_MASTERDATA_SUBLOCATION.SUCCESS:
      return {
        ...state,
        lists: action.payload.lists.data,
        total_rows: action.payload.lists.total,
        loading: false,
      }

    case CREATE_MASTERDATA_SUBLOCATION.REQUEST:
      return {
        ...state,
        loading: true,
      }

    case CREATE_MASTERDATA_SUBLOCATION.SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case UPDATE_MASTERDATA_SUBLOCATION.SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case EXPORT_MASTERDATA_SUBLOCATION.REQUEST:
      return {
        ...state,
        loading: true,
      }

    case EXPORT_MASTERDATA_SUBLOCATION.SUCCESS:
      return {
        ...state,
        loading: false,
      }

    default:
      return state
  }
}
